import { render } from "./NotificationSnackbar.vue?vue&type=template&id=ac1d479e"
import script from "./NotificationSnackbar.vue?vue&type=script&lang=js"
export * from "./NotificationSnackbar.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/estate-boost-frontend/estate-boost-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__